const getFileExtension = (filename) => {
  return filename.split('.').pop().toLowerCase();
};

export { getFileExtension }